<template>
  <GenericStep v-bind="$attrs">
    <MarriagesCard
      v-for="marriage of peParty.spouses"
      :key="marriage.id"
      class="mb-4"
      :form-only="true"
      :item="marriage"
    />

    <SectionAdderLine
      section="Marriage"
      :has-new-section="peMarriagesCardHasNewSection"
      @on-add="peMarriagesCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import MarriagesCard from '@/components/Party/PartyEdit/SectionCards/FamiliesCards/MarriagesCard.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'MarriagesStep',

  components: {
    GenericStep,
    MarriagesCard,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.spouses
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peMarriagesCardHasNewSection',
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peMarriagesCardAddSection',
    ]),
  },
}
</script>
